<ion-content>
    <div class="entry__header pt-1 pb-1 text-bold">
        <span>{{ formatedDate }}</span>
        <i (click)="close()" class="fa fa-xmark close-entry"></i>
    </div>
    <div class="entry__mood entry-border pt-1 pb-1 ion-text-center">
        <div class="entry-title text-bold">{{ lang.data['mood_entry.title'] }}</div>
        <img class="entry__mood-icon" [src]="selectedMood.iconActive" alt="icon">
        <div class="entry__mood-content text-bold">{{ selectedMood.title }}</div>
    </div>
    <div class="entry__feelings entry-border pt-1 pb-1 ion-text-center">
        <div class="entry-title text-bold">{{ lang.data['feeling_entry.title'] }}</div>
        <div class="ef-items">
            <div class="ef-item" *ngFor="let feeling of entry.feelingIds">{{ feeling.title }}</div>
        </div>
    </div>
    <div class="entry__notes entry-border pt-1 pb-1 ion-text-center">
        <div class="entry-title text-bold">{{ lang.data['label.notes'] }}:</div>
        <div class="en-content">
            <ng-container *ngIf="entry.note">
                {{ entry.note }}
            </ng-container>
            <ng-container *ngIf="!entry.note">
                {{ lang.data['label.empty_note'] }}
            </ng-container>
        </div>
        <hr>
    </div>
    <div class="entry__articles entry-border pt-1 pb-1">
        <div class="entry-title text-bold ion-text-center">{{ lang.data['recommended_entry.title'] }}</div>
        <ul class="ea-items">
            <li class="link mb-1" *ngFor="let article of articles.slice(0,5)" (click)="goToArticle(article.slug)">{{ article.title }}</li>
        </ul>
    </div>

    <div class="entry__actions pt-1 pb-3">
        <div class="action-item"  (click)="editEntry()">
            <ion-icon name="create"></ion-icon>
            <span class="text-bold">{{ lang.data['action.edit_entry'] }}</span>
        </div>
        <div class="action-item" (click)="deleteEntry()">
            <ion-icon name="trash"></ion-icon>
            <span class="text-bold">{{ lang.data['action.delete_entry'] }}</span>
        </div>
    </div>
</ion-content>
